<nb-card>
  <nb-card-body class="p-0" style="overflow: hidden">
    <p>
      <span class="weight-600">Step 1:</span> Link your
      {{ cloudProviderType | titlecase }} Account which can be used while
      creating projects or launching the environments.
    </p>
    <app-reactive-form-field
      label="Name"
      [required]="true"
      [showInfoAsTooltip]="false"
      labelSize="5"
      fieldId="name"
      fieldName="name"
      inputSize="7"
      [disabled]="webhookId?.length || alertDescription?.length"
      placeholder="Enter unique name for the account"
      [customFormControl]="accountName"
      missingMsg="{{ cloudProviderType | titlecase }} account name is required!"
      invalidPatternMsg="{{
        cloudProviderType | titlecase
      }} account name should be a lowercase alphanumeric string and can only have hyphens"
      class="mt-4"
    ></app-reactive-form-field>
    <div *ngIf="enableStepTwo && consoleCommand?.length" class="mt-2">
      <div>
        <p>
          <span class="weight-600">Step 2:</span>
          <span *ngIf="['AWS', 'AZURE', 'GCP'].includes(cloudProviderType)">
            Copy the command below and paste it into your
            <a [href]="cloudShelllinkMap[cloudProviderType]" target="_blank">
              {{ cloudProviderType | titlecase }} console Cloud Shell </a
            >. Once you run it, we'll automatically detect if the connection has
            been established successfully.
          </span>
          <span *ngIf="cloudProviderType === 'KUBERNETES'">
            Copy the command below and execute it in your terminal with the
            'kubeconfig' loaded, we'll automatically detect if the connection
            has been established successfully.
          </span>
        </p>
        <p class="py-2 px-2 mt-2 command d-flex justify-content-between">
          <code class="code-block">{{ consoleCommand }}</code>
          <app-copy-icon-with-tooltip
            [copyText]="consoleCommand"
            iconColor="#fff"
          ></app-copy-icon-with-tooltip>
        </p>
      </div>
    </div>
    <div
      *ngIf="pollingWebhook && enableStepTwo"
      class="d-flex align-items-center flex-column mt-2"
    >
      <div
        class="account-custom-spinner"
        [nbSpinner]="true"
        nbSpinnerSize="giant"
        nbSpinnerStatus="primary"
      ></div>
      <div class="mt-1 text-center weight-600">
        <p class="mb-0">Authorizing Cloud Integration.</p>
        <p>We're now waiting for you to execute the command.</p>
      </div>
    </div>
    <app-user-note-alert
      *ngIf="alertDescription?.length"
      [type]="alertType"
      [title]="alertTitle"
      [description]="alertDescription"
    >
    </app-user-note-alert>
  </nb-card-body>
  <nb-card-footer class="p-0 pt-3">
    <app-rbac-button
      *ngIf="!pollingWebhook && (!alertDescription?.length || webhookError)"
      label="Next"
      class="mr-3"
      status="primary"
      [action]="ACCOUNTS_WRITE"
      [loading]="generatingWebhookId || pollingWebhook || fetchingCpAccount"
      [disabled]="!accountName?.value?.length"
      (onClick)="generateWebhook()"
    ></app-rbac-button>
    <button
      *ngIf="enableStepTwo && !alertDescription?.length"
      nbButton
      size="small"
      class="mr-3"
      status="primary"
      appearance="outline"
      (click)="resetInputs()"
    >
      Back
    </button>
    <button
      nbButton
      [status]="alertDescription?.length ? 'primary' : 'control'"
      size="small"
      class="mr-3"
      (click)="closePopup()"
    >
      {{ alertDescription?.length && !webhookError ? 'Done' : 'Cancel' }}
    </button>
  </nb-card-footer>
</nb-card>
